module.exports = __webpack_public_path__ + "static/HYDROMAX-2e77322a0b8482df93d03447a7802b9d.svg";